import ResourceList from '../../resource/list';

const AssetsList = () => {

      return(
        <div>
          <ResourceList resource="scenes" name="Scenes"/>
        </div>
      )

}

export default AssetsList;